var _rect, _ellipse, _ellipse2, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDots = function SvgDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 23,
    viewBox: "0 0 34 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.599,
    y: 0.744,
    width: 32.627,
    height: 21.068,
    rx: 10.534,
    stroke: "#ECEFF3",
    strokeWidth: 0.958
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.154,
    cy: 11.278,
    rx: 1.436,
    ry: 1.439,
    transform: "rotate(-90 11.154 11.278)",
    fill: "#116DFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.912,
    cy: 11.278,
    rx: 1.436,
    ry: 1.439,
    transform: "rotate(-90 16.912 11.278)",
    fill: "#116DFF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.669,
    cy: 11.278,
    rx: 1.436,
    ry: 1.439,
    transform: "rotate(-90 22.669 11.278)",
    fill: "#116DFF"
  })));
};
export default SvgDots;